import React, { useState } from 'react';
import TranslationText from '../../../components/Translation/TranslationText';
import { CircleSyncSvg } from "components/icons/CircleSyncSvg";
import FetcherApi from "components/components/FetcherApi";

export function SmartIdProfileUpdateStep(props) {
	const [saveInProgress, setSaveInProgress] = useState(false);

	const onYesClick = async e => {
		setSaveInProgress(true);

		await FetcherApi.post("/api/smartid/update-profile");

		props.nextStep(e);
	};

	const onNoClick = e => {
		props.nextStep(e);
	};

	return (
		<div className="row row-center">
			<div className="column-desktop-8 column-tablet-12 column-mobile-12 centered-content">
				<div className="wizard-top-centered-icon">
					<CircleSyncSvg />
				</div>
			</div>
			<div className="column-desktop-8 column-tablet-12 column-mobile-12 centered-content">
				<div className="page-description-row bolded-text">
					<p style={{ fontWeight: "500" }}>
						<TranslationText text='smart_id_profile_update_page_verification_question' />
					</p>
				</div>
				<div className="two-buttons-row">
					<button onClick={onNoClick} className="button -secondary" disabled={saveInProgress}>
						<span>
							<TranslationText text='smart_id_profile_update_page_verification_no_label' />
						</span>
					</button>
					<button onClick={onYesClick} className="button -primary" disabled={saveInProgress}>
						<span>
							<TranslationText text='smart_id_profile_update_page_verification_yes_label' />
						</span>
					</button>
				</div>
			</div>
		</div>
	);
}
